import useShiftTimes from "../Hooks/useShiftTimes";
import { DashboardCard } from "./DashboardCard";
import { HourlyMetricsCard } from "./DashboardCards/HourlyMetricsCard";
import { MaterialMovementCard } from "./DashboardCards/MaterialMovementCard";
import { PlantStatusCard } from "./DashboardCards/PlantStatusCard";
import useShiftLockInfo from "../Hooks/useShiftLockInfo";

export const DashboardGrid: React.FC = () => {
  const { selectedDate, selectedShift } = useShiftTimes();
  const { shiftLockState } = useShiftLockInfo(selectedDate, selectedShift);

  return (
    <div className="grid gap-6 xl:gap-8 grid-cols-12 justify-items-center justify-center">
      <DashboardCard
        key="material-movement-card"
        title="Material Movement"
        linkTo="/production/show"
        linkTooltip="Open Production"
        linkAccess={(m) => [m.mining, m.lotusHall]}
        colSpan={{ base: 12, "xl": 6 }}
      >
        <MaterialMovementCard shiftLockState={shiftLockState} />
      </DashboardCard>
      <DashboardCard
        key="plant-status-card"
        title="Plant Status"
        linkTo="/stoppages"
        linkTooltip="Open Stoppages"
        linkAccess={(m) => [m.mining, m.lotusHall, m.maintenance]}
        colSpan={{ base: 12, "xl": 6 }}
      >
        <PlantStatusCard shiftLockState={shiftLockState} />
      </DashboardCard>
      <DashboardCard
        key="hourly-metrics-card"
        title="Hourly Metrics"
        linkTo="/reports/daily"
        linkTooltip="Open Daily Report"
        linkAccess={(m) => [m.mining]}
        colSpan={{ base: 12 }}
      >
        <HourlyMetricsCard shiftLockState={shiftLockState} />
      </DashboardCard>
    </div>
  );
};